import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SortingComponent} from '@spartacus/storefront';
import {SortModel} from '@spartacus/core';
import {DcpEddlSearchTrackingService} from '@app/services/analytics/EDDL/dcp-eddl-search-tracking.service';

@Component({
  selector: 'dcp-sorting-dropdown',
  templateUrl: './sorting-dropdown.component.html'
})
export class SortingDropdownComponent extends SortingComponent {

  @Input() sortOptions: SortModel[] | undefined;
  @Input() selectedOption: string | undefined;
  @Input() placeholder: string;
  @Input() sortLabels: { [code: string]: string } | null;

  @Output() sortListEvent: EventEmitter<string>;

  constructor(
    private eddlSearchTrackingService: DcpEddlSearchTrackingService
  ) {
    super();
  }

  get selectedOptionName(): string {
    if (!this.sortOptions) {
      return undefined;
    }
    const selectedOption: SortModel = this.sortOptions?.find((option) => option.code === this.selectedOption);
    if (!selectedOption) {
      return undefined;
    }
    return selectedOption.name;
  }

  getSortCode(e: CustomEvent): void {
    const selectedOptionCode: string = this.sortOptions?.find((option) => option.name === e.detail.item._state.label).code;
    this.sortList(selectedOptionCode);
  }

  sortList(sortCode: string): void {
    this.eddlSearchTrackingService.sortFilterOrPaginationHitEvent = true;
    super.sortList(sortCode);
  }
}
